var $ = jQuery;

$(document).ready(function () {
  let packagingPrice = 0;
  let selectedPackagingId = null;
  let selectedProducts = {};
  let minProducts = 0;
  let maxProducts = 0;
  let cartItemsById = {};

  // Load current cart
  $.getJSON('/cart.js', function (cart) {
    cart.items.forEach(function (item) {
      cartItemsById[item.id] = item.quantity;
    });
  });

  function showMessage(text) {
    $('#message')
      .stop(true, true)
      .text(text)
      .fadeIn()
      .delay(3000)
      .fadeOut();
  }

  function updateRangeLabel() {
    $('#product-range-label').text(`min. ${minProducts} und max. ${maxProducts} Produkte möglich`);
  }

  const firstPackaging = $('.packaging-option').first();
  if (firstPackaging.length > 0) {
    firstPackaging.addClass('selected');
    packagingPrice = parseFloat(firstPackaging.data('price'));
    selectedPackagingId = parseInt(firstPackaging.data('id'));
    minProducts = parseInt(firstPackaging.data('min'));
    maxProducts = parseInt(firstPackaging.data('max'));
    updateRangeLabel();
  }

  function getTotalQty() {
    return Object.values(selectedProducts).reduce((acc, item) => acc + item.qty, 0);
  }


  function renderDots() {
    const totalQty = getTotalQty();
    const dotsContainer = $('.progress-dots');
    dotsContainer.empty();

    for (let i = 1; i <= maxProducts; i++) {
      const dot = $('<div class="dot"></div>');
      if (i <= totalQty) {
        dot.addClass('filled'); 
      }
      dotsContainer.append(dot);
    }
}


  function updateTotal() {
    $('.custom-qty-box').removeClass('disabled-item'); // reset UI state
    let productTotal = 0;
    let totalQty = 0;
    $('.selected-list').empty();

    $.each(selectedProducts, function (id, item) {
      if (item.qty > 0) {
        productTotal += item.qty * parseFloat(item.price);
        totalQty += item.qty;
        $('.selected-list').append(`
          <div class="selected-item" data-id="${id}">
            <div class="item-info">
              <div class="item-info-top">
                <img class="selected-image" src="${item.image}" alt="${item.title}">
              </div>
              <div class="item-info-bottom">
                <span class="item-title">${item.title}</span>
                <span class="item-price">${(item.price * item.qty).toFixed(2).replace('.', ',')}</span>
              </div>
            </div>
            <div class="qty-control">
              <button class="decrease" data-id="${id}">-</button>
              <span>${item.qty}</span>
              <button class="increase" data-id="${id}">+</button>
            </div>
          </div>
        `);
      }
    });

    const total = productTotal + packagingPrice;
    $('#total-price').text(total.toFixed(2).replace('.', ',') + ' €');

    if (totalQty >= minProducts && totalQty <= maxProducts) {
      $('#add-to-cart').prop('disabled', false);
      $('#progress-message').text('');
      $('#message').hide();
    } else {
      $('#add-to-cart').prop('disabled', true);
      if (totalQty < minProducts) {
        const remaining = minProducts - totalQty;
        $('#progress-message').text(` Fast geschafft! Füge noch  ${remaining} Artikel hinzu, um deine Pralinenschachtel zu erhalten.`);
      } else if (totalQty > maxProducts) {
        $('#progress-message').text('');
        showMessage(`Bitte nicht mehr als ${maxProducts} Artikel auswählen.`);
      } else if (packagingPrice === 0) {
        $('#progress-message').text('');
        showMessage('Bitte wähle eine Verpackungsoption aus.');
      }
    }

    syncQuantitiesUI();
    renderDots();

  }

  function syncQuantitiesUI() {
    $('.grid__item').each(function () {
      const id = $(this).data('id');
      if (selectedProducts[id]) {
        $(this).find('.qty').text(selectedProducts[id].qty);
      } else {
        $(this).find('.qty').text(0);
      }
    });
  }

  $('.packaging-option').click(function () {
    $('.packaging-option').removeClass('selected');
    $(this).addClass('selected');

    packagingPrice = parseFloat($(this).data('price'));
    selectedPackagingId = parseInt($(this).data('id'));
    minProducts = parseInt($(this).data('min'));
    maxProducts = parseInt($(this).data('max'));
    updateRangeLabel();
    updateTotal();
  });

  // PLUS from grid
  $(document).on('click', '.plus', function () {
    const parent = $(this).closest('.grid__item');
    const id = parent.data('id');
    const title = parent.data('title');
    const price = parent.data('price');
    const image = parent.data('image');
    const available = parent.data('available');
    const inventory = parent.data('inventory') || 0;
    const cartQty = cartItemsById[id] || 0;
    const currentQty = selectedProducts[id]?.qty || 0;

    if (!available) return;

    if ((currentQty + cartQty) < inventory && getTotalQty() < maxProducts) {
      if (!selectedProducts[id]) {
        selectedProducts[id] = { qty: 0, price: price, title: title, image: image };
      }
      selectedProducts[id].qty++;
      parent.find('.qty').text(selectedProducts[id].qty);
      $('#message').hide();
      updateTotal();
    } else {
      const remaining = inventory - cartQty;
      showMessage(`Nur noch ${remaining} Stück verfügbar (bereits ${cartQty} im Warenkorb).`);
      parent.find('.custom-qty-box').addClass('disabled-item');
    }
  });

  // MINUS from grid
  $(document).on('click', '.minus', function () {
    const parent = $(this).closest('.grid__item');
    const id = parent.data('id');
    if (selectedProducts[id] && selectedProducts[id].qty > 0) {
      selectedProducts[id].qty--;
      parent.find('.qty').text(selectedProducts[id].qty);
      updateTotal();
    }
  });

  // INCREASE from summary
  $(document).on('click', '.increase', function () {
    const id = $(this).data('id');
    const gridItem = $(`.grid__item[data-id="${id}"]`);
    const inventory = gridItem.data('inventory') || 0;
    const cartQty = cartItemsById[id] || 0;
    const currentQty = selectedProducts[id]?.qty || 0;

    if ((currentQty + cartQty) < inventory && getTotalQty() < maxProducts) {
      selectedProducts[id].qty++;
      $('#message').hide();
      updateTotal();
    } else {
      const remaining = inventory - cartQty;
      showMessage(`Nur noch ${remaining} Stück verfügbar (bereits ${cartQty} im Warenkorb).`);
      gridItem.find('.custom-qty-box').addClass('disabled-item');
    }
  });

  // DECREASE from summary
  $(document).on('click', '.decrease', function () {
    const id = $(this).data('id');
    if (selectedProducts[id] && selectedProducts[id].qty > 0) {
      selectedProducts[id].qty--;
      updateTotal();
    }
  });

  // ADD TO CART
$('#add-to-cart').click(function () {
  const formData = [];
  const bundleGroup = 'bundle_' + Date.now();

  if (selectedPackagingId) {
    formData.push(`items[0][id]=${selectedPackagingId}`);
    formData.push(`items[0][quantity]=1`);
    formData.push(`items[0][properties][_bundle_group]=${encodeURIComponent(bundleGroup)}`);
    formData.push(`items[0][properties][_bundle_type]=packaging`);
  }

  let index = selectedPackagingId ? 1 : 0;

  $.each(selectedProducts, function (id, item) {
    if (item.qty > 0) {
      formData.push(`items[${index}][id]=${id}`);
      formData.push(`items[${index}][quantity]=${item.qty}`);
      formData.push(`items[${index}][properties][_bundle_group]=${encodeURIComponent(bundleGroup)}`);
      formData.push(`items[${index}][properties][_bundle_type]=product`);
      index++;
    }
  });

  if (formData.length > 0) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: formData.join('&'),
      contentType: "application/x-www-form-urlencoded",
      dataType: "json",
      success: function () {
        const currentUrl = window.location.pathname;
        window.location.href = currentUrl + '?open_cart=1';
      },
      error: function (err) {
        showMessage("Ein Fehler ist aufgetreten. Bitte versuche es erneut.");
        console.error("Cart Error:", err);
      }
    });
  } else {
    showMessage("Bitte Produkte auswählen, bevor du fortfährst.");
  }
});

  updateTotal();
  const params = new URLSearchParams(window.location.search);
  if (params.get('open_cart') === '1') {
    const icon = document.querySelector('#cart-icon-bubble');
    if (icon) icon.click();
    const url = new URL(window.location.href);
    url.searchParams.delete('open_cart');
    window.history.replaceState({}, document.title, url.pathname);
  }
  

  
});
